import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ICombinedStore } from './store.interface';
import { headerFooterSlice } from './headerFooter';
import { cartDataSlice } from './cartData';

export const useStore = create<ICombinedStore>()(
  devtools(
    (...a) => ({
      ...headerFooterSlice(...a),
      ...cartDataSlice(...a),
    }),
    {
      name: 'storage',
    }
  )
);
